/**
 * Tiny trend-line SVG. Inline, no axes, no labels — just the shape of
 * the values over time. 0-anchored y-axis so a halving cost shows as
 * the line dropping. Single-point series renders nothing.
 */
export function Sparkline({
  values,
  width = 80,
  height = 22,
  stroke = "var(--accent)",
  strokeWidth = 1.5,
}: {
  values: number[];
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
}) {
  if (values.length < 2) return null;
  const max = Math.max(...values);
  const denom = max > 0 ? max : 1;
  const stepX = width / (values.length - 1);
  const padY = strokeWidth;
  const usableHeight = height - padY * 2;
  const points = values
    .map((v, i) => {
      const x = i * stepX;
      const y = height - padY - (v / denom) * usableHeight;
      return `${x.toFixed(2)},${y.toFixed(2)}`;
    })
    .join(" ");
  const last = values[values.length - 1] ?? 0;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label={`Trend van ${values.length} events`}
      className="overflow-visible"
    >
      <polyline
        fill="none"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        points={points}
      />
      <circle
        cx={(values.length - 1) * stepX}
        cy={height - padY - (last / denom) * usableHeight}
        r={strokeWidth + 0.5}
        fill={stroke}
      />
    </svg>
  );
}
